import React from 'react';
import { formatBytes, formatDuration } from '../theme';

/**
 * Overall-job progress summary — total files, total bytes, elapsed/estimated
 * remaining, and a copying-vs-verifying breakdown of whatever's active right
 * now. Sits above the per-file rows (ActiveFileProgressRow) rather than
 * duplicating what each row already shows individually.
 */
export default function OverallProgressSummary({
  c, filesDone, fileCount, bytesDone, totalBytes, progressPct,
  copyingCount, verifyingCount, elapsedMs, phaseLabel,
}) {
  const rate = elapsedMs > 1000 && bytesDone > 0 ? bytesDone / (elapsedMs / 1000) : 0;
  const remainingBytes = Math.max(0, (totalBytes || 0) - (bytesDone || 0));
  const etaMs = rate > 0 ? (remainingBytes / rate) * 1000 : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
        <div style={{ fontSize: '12px', fontWeight: 600, color: c.text }}>
          {phaseLabel || 'Copying'} — {filesDone}/{fileCount} files
        </div>
        <div style={{ fontSize: '11px', color: c.muted }}>
          {formatBytes(bytesDone)} / {formatBytes(totalBytes)} · {progressPct}%
        </div>
      </div>

      <div style={{ height: '8px', borderRadius: '4px', background: c.rule, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${progressPct}%`, background: c.accent, transition: 'width 0.15s linear' }} />
      </div>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', fontSize: '10.5px', color: c.muted }}>
        <span>Elapsed {formatDuration(elapsedMs)}</span>
        <span>Remaining ~{etaMs !== null ? formatDuration(etaMs) : '—'}</span>
        {copyingCount > 0 && <span style={{ color: c.accent }}>{copyingCount} copying</span>}
        {verifyingCount > 0 && <span style={{ color: c.warn }}>{verifyingCount} verifying checksum</span>}
      </div>
    </div>
  );
}
